/**
 * G-R13 reversal: a phase's tasks are blocked by the previous phase's gate.
 * Names come from the plan the caller already has. Blank names return null
 * rather than a stand-in phase.
 */
export function formatPreviousPhaseGateWait(
  previousPhaseName: string | null | undefined,
  currentPhaseName: string | null | undefined,
): string | null {
  const previous = previousPhaseName?.trim() ?? '';
  const current = currentPhaseName?.trim() ?? '';
  if (!previous || !current) return null;
  return `Waiting for ${previous} → ${current} approval`;
}
